import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { downloadCsv, payrollBasisToCsv } from "@/lib/report-export";
import { usePayrollBasis } from "@/hooks/use-payroll-basis";

interface Props {
  /** Inklusiv periode (fra ReportShell). */
  period: { from: string; to: string };
}

/**
 * Grunnlags-CSV for lønnsgrunnlaget (VIB-1224): én rad per føring med dato og
 * type (lørdag/søndag/helligdag) + overnattinger, sum per ansatt og totalsum.
 * Ingen kroner — lønn kjører satsene selv (Erik 15.07).
 */
export default function PayrollBasisExport({ period }: Props) {
  const { data } = usePayrollBasis(period);

  const handleExport = () => {
    if (!data) return;
    downloadCsv(`lonnsgrunnlag-${period.from}_${period.to}.csv`, payrollBasisToCsv(data));
  };

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={handleExport}
      disabled={!data || data.length === 0}
    >
      <SrIcon name="download" className="w-3.5 h-3.5 mr-1.5" />
      Eksporter CSV
    </Button>
  );
}
